export { default as getFeatureFlagValue } from './feature-manager';
export type { WindowFlagVars } from './types';
export { initialiseFeatureGates } from './statsig-initialisation';
